import { Outlet, Link } from 'react-router-dom'

export default function App() {
  return (
    <div className="min-h-full flex flex-col">
      <header className="border-b border-zinc-800">
        <div className="mx-auto max-w-3xl flex items-center justify-between px-6 py-4">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            OnlyBans
          </Link>
          <nav className="text-sm text-zinc-400 space-x-4">
            <Link to="/dashboard" className="hover:text-zinc-100">
              Dashboard
            </Link>
            <Link to="/privacy" className="hover:text-zinc-100">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-zinc-100">
              Terms
            </Link>
          </nav>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-zinc-800 text-xs text-zinc-500">
        <div className="mx-auto max-w-3xl px-6 py-4">
          © {new Date().getFullYear()} OnlyBans
        </div>
      </footer>
    </div>
  )
}
